import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from "react-oidc-context";
import App from "./App";
import store from "./store/store";
import './styles/App.css';
import './styles/index.css'; 
import { Provider } from "react-redux";

const isDev = process.env.REACT_APP_ENV === "dev";
console.log(isDev);

const cognitoAuthConfig = {
  authority: "https://cognito-idp.eu-west-2.amazonaws.com/eu-west-2_ollWsHKba",
  client_id: "4ddg2f8q9gucu6tsghni1it2sj",
  redirect_uri: isDev ? "http://localhost:3000" : "https://www.partnerprivacy.winrdata.com",
  post_logout_redirect_uri: isDev ? "http://localhost:3000/logout" : "https://www.partnerprivacy.winrdata.com/logout",
  response_type: "code",
  scope: "phone openid email",
  automaticSilentRenew: true,
  useRefreshTokens: true
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <AuthProvider {...cognitoAuthConfig}>
          <App />
        </AuthProvider>
      </Provider>
    </BrowserRouter>
  // </React.StrictMode>
);